import { Stack, Theme } from '@mui/material';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import Text from '../text';
import Card from '../card';
import { CARD_SIZES, CardSize } from './helpers';

interface Props {
  title?: string;
  size?: CardSize;
}

const useStyles = createUseStyles((theme: Theme) => ({
  emptyCard: ({ size }: { size: CardSize }) => ({
    width: CARD_SIZES[size].width,
    height: CARD_SIZES[size].height,
    cursor: 'default',
    backgroundColor: theme.palette.lightGray,
  }),
}));

const EmptyCard: FC<Props> = ({ title = 'No records found', size = 'small' }) => {
  const styles = useStyles({ size });

  return (
    <Card className={styles.emptyCard}>
      <Stack alignItems="center" justifyContent="center" height="100%">
        <Text color="grey">{title}</Text>
      </Stack>
    </Card>
  );
};

export default EmptyCard;
